import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {checkBillingStatus} from "~/store/billingSlice.ts";
import {AppDispatch} from "~/store";
import Billing from "~/components/Billing.tsx";
import useAuthentication from "~/hooks/useAuthentication.ts";

interface BillingGuardProps {
    children: React.ReactNode;
}

export const BillingGuard: React.FC<BillingGuardProps> = ({ children }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { requiresBilling, currentPlan } = useSelector((state: any) => state.billing);
    const {getShopifySession} = useAuthentication();
    const session = getShopifySession();
    const shop = session?.shop || '';

    useEffect(() => {
        dispatch(checkBillingStatus(shop));
    }, [dispatch, shop]);

    if (requiresBilling && (!currentPlan || currentPlan.status !== 'active')) {
        return (
            <Billing />
        )
    }

    return <>{children}</>;
};
